import { PapiComment, PapiNcComment, PapiUser } from '@wix/da-papi-types';
import {
  DrawerStreamParams,
  BucketStreamParams,
  CommentStreamParams,
} from '../types';
import { reduxKey } from '../constants';
import { PapiDrawerItem } from '../types/papi';

export function getBucketStreamId(params: BucketStreamParams) {
  return [
    reduxKey,
    'bucket',
    params.folder,
    params.bucket,
    params.filterId,
  ].join(':');
}

export function getDrawerStreamId(params: DrawerStreamParams) {
  return [reduxKey, 'drawer', params.folder].join(':');
}

export function getNotificationCommentStreamId(params: CommentStreamParams) {
  return [reduxKey, 'comments', params.messageId].join(':');
}

export function isBucketStream(streamId: string) {
  return streamId.startsWith(`${reduxKey}:bucket`);
}

export function isNotificationStream(streamId: string) {
  return (
    streamId.startsWith(`${reduxKey}:bucket`) ||
    streamId.startsWith(`${reduxKey}:drawer`)
  );
}

export function isUser(val): val is PapiUser {
  return val && typeof val === 'object' && val.hasOwnProperty('username');
}

export function ncCommentToPapiComment(comment: PapiNcComment): PapiComment {
  return {
    ...comment,
    // Compat types
    edited: comment.edited ?? null,
    isSpam: !!comment.isSpam,
    isDeleted: !!comment.isDeleted,
    isAuthor: !!comment.isAuthor,
    isAuthorHighlited: !!comment.isAuthorHighlited,
    isFeatured: !!comment.isFeatured,
    isReportable: !!comment.isReportable,
    isLiked: !!comment.isLiked,
    isOwner: !!comment.isOwner,

    // Removed
    // TODO need to refactor comments to not rely on the below, for now
    // and in the context on NC this should be good enough
    isViolation: false,
    isAdminHidden: false,
    isHidden: false,
    isLocked: false,
    isPrivate: false,
    isAnnotation: false,
    isAdminMode: false,
    hidden: null,
    signature: null,
    authorInfo: null,
  };
}

export function isAllFeed(streamId): boolean {
  return /user_feed_all|group_feed_all/.test(streamId);
}

export function isBucketSingleItem(item: PapiDrawerItem) {
  return (
    item.bucket &&
    item.message &&
    item.bucket?.countDetails?.length === 1 &&
    item.bucket.countDetails[0].newCount === 1
  );
}
